(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("taxLabelService", [taxLabelService]);
    function taxLabelService() {
        var taxLabelServiceFactory = {};
        var countryTaxList = [
            { label: "GST", name: "common.tax.GST" },
            { label: "SalesTax", name: "common.tax.SalesTax" },
            { label: "Tax", name: "common.tax.Tax" },
            { label: "Taxes", name: "common.tax.Taxes" },
            { label: "VAT", name: "common.tax.VAT" }
        ];
        var regionTaxList = [
            { label: "HST", name: "common.tax.HST" },
            { label: "PST", name: "common.tax.PST" },
            { label: "QST", name: "common.tax.QST" },
            { label: "StateTax", name: "common.tax.StateTax" }
        ];
        var taxTypeList = [
            { type: "Instead", name: "common.taxType.Instead" },
            { type: "Added", name: "common.taxType.Added" }
            //, { type: "Compounded", name: "common.taxType.Compounded" }
        ];
        taxLabelServiceFactory.countryTaxList = countryTaxList;
        taxLabelServiceFactory.regionTaxList = regionTaxList;
        taxLabelServiceFactory.taxTypeList = taxTypeList;
        return taxLabelServiceFactory;
    }
}());
